import JshModule from '@core/scripts/helper/jsh-module';

const MOBILE_BREAKPOINT = 768;
const AUTO_ADVANCE_INTERVAL_MS = 4000;
const SWIPE_THRESHOLD_PX = 40;

do {
    const {moduleScope} = JshModule('teaser/benefit-communication');

    if (moduleScope === null) {
        continue;
    }

    const benefitModules = Array.from(document.querySelectorAll('[jsh-module__loaded="teaser/benefit-communication"]'));
    if (benefitModules[0] !== moduleScope) {
        moduleScope.remove();
        continue;
    }


    const items = Array.from(moduleScope.querySelectorAll('.content-platform__benefit-communication__item'));

    if (items.length <= 1) {
        continue;
    }

    let activeIndex = 0;
    let swipeStartX = 0;
    let swipeStartY = 0;
    let timerId = null;

    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const indicatorsEl = document.createElement('div');
    indicatorsEl.className = 'content-platform__benefit-communication__indicators';
    indicatorsEl.setAttribute('aria-hidden', 'true');
    const dots = items.map((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'content-platform__benefit-communication__indicator' + (i === 0 ? ' -active' : '');
        indicatorsEl.appendChild(dot);
        return dot;
    });

    function showItem(index) {
        items.forEach((item, i) => {
            if (i === index) {
                item.classList.remove('-mobile-hidden');
                item.classList.remove('-animating-in');
                void item.offsetWidth; // force reflow to restart animation
                item.classList.add('-animating-in');
            } else {
                item.classList.add('-mobile-hidden');
                item.classList.remove('-animating-in');
            }
        });
        dots.forEach((dot, i) => dot.classList.toggle('-active', i === index));
        activeIndex = index;
    }

    function startTimer() {
        timerId = setInterval(() => showItem((activeIndex + 1) % items.length), AUTO_ADVANCE_INTERVAL_MS);
    }

    function resetTimer() {
        clearInterval(timerId);
        startTimer();
    }

    moduleScope.addEventListener('touchstart', (e) => {
        if (!mq.matches) return;
        const t = e.touches[0];
        if (t) { swipeStartX = t.clientX; swipeStartY = t.clientY; }
    }, {passive: true});

    moduleScope.addEventListener('touchend', (e) => {
        if (!mq.matches) return;
        const t = e.changedTouches[0];
        if (!t) return;
        const dx = swipeStartX - t.clientX;
        const dy = swipeStartY - t.clientY;
        if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dx) <= Math.abs(dy)) return;
        showItem((activeIndex + (dx > 0 ? 1 : -1) + items.length) % items.length);
        resetTimer();
    }, {passive: true});


    function applyMode(isMobile) {
        if (isMobile) {
            showItem(0);
            moduleScope.appendChild(indicatorsEl);
            startTimer();
        } else {
            clearInterval(timerId);
            items.forEach(item => item.classList.remove('-mobile-hidden', '-animating-in'));
            if (indicatorsEl.parentNode) indicatorsEl.parentNode.removeChild(indicatorsEl);
        }
    }

    mq.addEventListener('change', (e) => applyMode(e.matches));
    applyMode(mq.matches);

} while (document.querySelector('[jsh-module="teaser/benefit-communication"]') !== null);
